export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idPersona: idPadre,
    pariente: null,
    tipoParentesco: null,
  };
};

export const saveItem = (item) => {
  return {
    id: item.id,
    idPersona: item.idPersona,
    idPersonaPariente: item.pariente && item.pariente.id,
    codTipoParentesco: item.tipoParentesco && item.tipoParentesco.codigo,
  };
};
